import ContactNoteCreateForm from './ContactNoteCreateForm';

export default ContactNoteCreateForm;
